import React, { useEffect, useRef, useState } from "react";
import { getTotalSpentTime } from "../../utility/getTotalSpentTime";
import { updateTask, useProjectList, useTaskSubtaskList } from "./api";
import { isValidTime } from "../../utility/validTime";

interface SelectedTask {
  task: string;
  isSubTask: boolean;
  taskId: string;
}

const LogTimeList: React.FC<any> = ({
  logsList,
  handleUpdate,
  handleTaskUpdate,
  handleClone,
  handleDelete,
  timer
  //   projectList,
  //   taskSubtaskList,
}) => {
  const [limit, setLimit] = useState(10);
  const projectsDropdownRefs = useRef<{ [key: string]: HTMLDivElement | null }>(
    {}
  );
  const tasksDropdownRefs = useRef<{ [key: string]: HTMLDivElement | null }>(
    {}
  );
  const [taskSearchQuery, setTaskSearchQuery] = useState("");
  const [startTime, setStartTime] = useState<{[key: string]: string;}>({});
  const [endTime, setEndTime] = useState<{[key: string]: string;}>({});

  const [projectId, setProjectId] = useState("");
  const [isProjectClick, setIsProjectClick] = useState(false);
  const [projectSearchQuery, setProjectSearchQuery] = useState("");

  const { projectList, isProjectListLoading, isError } = useProjectList(
    limit,
    projectSearchQuery
  );

  const [taskId, setTaskId] = useState("");

  const { taskSubtaskList, isTaskSubtaskListLoading, isTaskError } =
    useTaskSubtaskList(projectId, limit, taskSearchQuery);

  const [openProjectDropdownId, setOpenProjectDropdownId] = useState<
    string | null
  >(null);
  const [openTaskDropdownId, setOpenTaskDropdownId] = useState<string | null>(
    null
  );

  const [selectedProjects, setSelectedProjects] = useState<{
    [key: string]: string;
  }>({});

  const [selectedTasks, setSelectedTasks] = useState<{
    [key: string]: SelectedTask;
  }>({});

  const handleTasksSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setTaskSearchQuery(e.target.value);
  };

  const handleProjectsSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setProjectSearchQuery(e.target.value);
  };

  const toggleProjectDropdown = (logId: string) => {
    // setOpenProjectDropdownId((prevState) =>
    //   prevState === logId ? null : logId
    // );
  };

  // Toggle the task dropdown
  const toggleTaskDropdown = (log: any) => {
    if(!isProjectClick){
      setProjectId(log.projectId._id);
    }
    setOpenTaskDropdownId((prevState) => (prevState === log._id ? null : log._id));
  };

  const handleProjectsClick = (id: string, projectName: string, logId: any) => {
    // setIsProjectClick(true);
    // setProjectId(id);

    // setSelectedProjects((prev) => ({
    //   ...prev,
    //   [logId]: projectName,
    // }));

    // setOpenProjectDropdownId(null);
  };

  const handleSubtaskClick = (
    taskId: string,
    taskUniqueId: string,
    subTask: any,
    logId: string
  ) => {
    setSelectedTasks((prevState) => ({
      ...prevState,
      [logId]: { task: subTask.name, isSubTask: true, taskId: subTask._id },
    }));

    handleTaskUpdate(logId,projectId,taskId,taskUniqueId,subTask._id);
 
    setOpenTaskDropdownId(null);
  };

  const handleTaskClick = (logId: string, task: any) => {
    // setIsActiveTaskDrop((prevState) => !prevState);
    setTaskId(task._id);
    setSelectedTasks((prevState) => ({
      ...prevState,
      [logId]: { task: task.name, isSubTask: false, taskId: task.taskId },
    }));

    handleTaskUpdate(logId,projectId,task._id,task._id,"");

    setOpenTaskDropdownId(null);
    // setSelectedTask({ task: task.name, isSubTask: false, taskId: task.taskId });
  };

  //   const toggleDropdown = (logId: string, type: "project" | "task") => {
  //     setOpenDropdownId((prevState) => {
  //       if (type === "project") {
  //         return {
  //           project: prevState.project === logId ? null : logId, // Toggle project dropdown
  //           task: prevState.task, // Keep task dropdown unchanged
  //         };
  //       }
  //       return {
  //         project: null, // Close project dropdown when task is clicked
  //         task: prevState.task === logId ? null : logId, // Toggle task dropdown
  //       };
  //     });
  //   };

const handleStartTimeChange = (logId:string, e: React.ChangeEvent<HTMLInputElement>) => {
  setStartTime((prevState) => ({
    ...prevState,
    [logId]: e.target.value,
  }));

}

const handleEndTimeChange = (logId:string, e: React.ChangeEvent<HTMLInputElement> ) => {
  setEndTime((prevState) => ({
    ...prevState, 
    [logId]: e.target.value,
  }));
}

  return (
    <>
      <div className="logtime-table">
        <div className="list-table-comp">
          <div className="list-table-header">
            <div className="l-t-item l-t-i-project">Project</div>
            <div className="l-t-item l-t-i-task-subtask">Task/Subtask</div>
            <div className="l-t-item l-t-i-priority">Priority</div>
            <div className="l-t-item l-t-i-start-time">Start Time</div>
            <div className="l-t-item l-t-i-end-time">End Time</div>
            <div className="l-t-item l-t-i-time-spent">Time Spent</div>
          </div>
          <div className="list-table-body">
            {logsList?.map((log: any) => (
              <div className="l-t-b-item">
                <div className="l-t-item l-t-i-project">
                  <div
                    ref={(el) => (projectsDropdownRefs.current[log._id] = el)}
                    className={`l-w-project dropdown-comp ${
                      openProjectDropdownId === log._id ? "active" : ""
                    }`}
                  >

                    <div className="dropdown-trigger" onClick={() => toggleProjectDropdown(log._id)}>
                      <div
                        className="dropdown-trigger-text"
                        
                      > 
                        {selectedProjects[log._id] ||
                          log.projectId.project_name}
                      </div>
                      <span className="material-icons-round">
                        keyboard_arrow_down
                      </span>
                    </div>
                    {/* {openDropdownId === log._id && ( */}
                    <div className="dropdown-content">
                      <div className="d-c-group d-c-group__header">
                        <div className="d-c-g-title">
                          <span>Project</span>
                        </div>
                        <div className="search-comp">
                          <span className="material-icons-outlined">
                            search
                          </span>
                          <input
                            type="text"
                            value={projectSearchQuery}
                            onChange={handleProjectsSearch}
                            placeholder="Search"
                          />
                        </div>
                      </div>
                      <div className="d-c-group d-c-group__body">
                        <div className="d-c-group-item">
                          <div className="d-c-g-title">
                            <span>SCT Base Tool</span>
                          </div>
                          <div className="d-c-g-item-block ">
                            {projectList?.map((project: any) => (
                              <a
                                key={project._id}
                                onClick={() =>
                                  handleProjectsClick(
                                    project._id,
                                    project.project_name,
                                    log._id
                                  )
                                }
                                className="d-c-item d-c-project-item"
                              >
                                <div className="d-c-p-i-top">
                                  <span className="material-icons-outlined">
                                    fiber_manual_record
                                  </span>
                                  {project.project_name}
                                </div>
                              </a>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* )} */}
                  </div>
                </div>
                <div className="l-t-item l-t-i-task-subtask">
                  <div
                    ref={(el) => (tasksDropdownRefs.current[log._id] = el)}
                    className={`l-w-task-subtask dropdown-comp dropdown-lg-comp ${
                      openTaskDropdownId === log._id ? "active" : ""
                    } ${
                      log.subTask === "None" ? "task-active" : "subtask-active"
                    }`}
                  >
                    <div className="dropdown-trigger" onClick={() => toggleTaskDropdown(log)}>
                      <div className="d-t-left">
                        <div className="l-w-t-s-icon">
                          <span className="material-icons-outlined default-task-icon">
                            done_outline
                          </span>
                          <span className="material-icons-outlined task-icon">
                            bolt
                          </span>
                          <span className="material-icons-outlined subtask-icon">
                            subdirectory_arrow_right
                          </span>
                        </div>
                        <div className="l-w-t-s-code">
                          {log.subTask === "None"
                            ? log.taskId.taskId
                            : log.subTask}
                        </div>
                        <div
                          className="l-w-t-s-text"
                        >
                          {selectedTasks[log._id]?.task
                            ? selectedTasks[log._id]?.task
                            : log.subTask === "None"
                            ? log.taskId.name
                            : log?.taskId?.subTasks
                                ?.filter((sub: any) => sub._id === log.subTask)
                                .map((sub: any) => sub.name)}
                        </div>
                      </div>
                      <span className="material-icons-round">
                        keyboard_arrow_down
                      </span>
                    </div>
                    <div className="dropdown-content">
                      <div className="d-c-group d-c-group__header">
                        <div className="d-c-g-title">
                          <span>Task/Subtask</span>
                        </div>
                        <div className="search-comp">
                          <span className="material-icons-outlined">
                            search
                          </span>
                          <input
                            type="text"
                            value={taskSearchQuery}
                            onChange={handleTasksSearch}
                            placeholder="Search"
                          />
                        </div>
                      </div>
                      <div className="d-c-group d-c-group__body">
                        {/* <div className='d-c-group-item'>
                <div className="d-c-g-title no-boarder">
                  <span>No Record Founded</span>
                </div>
              </div> */}
                        <div className="d-c-group-item">
                          <div className="d-c-g-title">
                            {/* <span>{selectedProject}</span> */}
                          </div>
                          <div className="d-c-g-item-block">
                            {taskSubtaskList?.map((task: any) => (
                              <React.Fragment key={task._id}>
                                <a
                                  onClick={() => {
                                    handleTaskClick(log._id, task);
                                  }}
                                  className="d-c-item d-c-task-item"
                                >
                                  <div className="d-c-p-i-top">
                                    <span className="material-icons-outlined">
                                      bolt
                                    </span>
                                    <div className="l-w-t-s-code">
                                      {task.taskId}
                                    </div>
                                  </div>
                                  <div className="d-c-p-i-middle">
                                    {" "}
                                    {task.name}{" "}
                                  </div>
                                </a>

                                {task.subTasks?.map((subTask: any) => (
                                  <a
                                    key={subTask._id}
                                    onClick={() => {
                                      handleSubtaskClick(
                                        task.taskId,
                                        task._id,
                                        subTask,
                                        log._id
                                      );
                                    }}
                                    className="d-c-item d-c-subtask-item"
                                  >
                                    <div className="d-c-p-i-top">
                                      <span className="material-icons-outlined">
                                        subdirectory_arrow_right
                                      </span>
                                      <div className="l-w-t-s-code">
                                        {subTask._id}
                                      </div>
                                    </div>
                                    <div className="d-c-p-i-middle">
                                      {subTask.name}
                                    </div>
                                  </a>
                                ))}
                              </React.Fragment>
                            ))}
                          </div>
                        </div>
                      </div>
                      {/* <div className="d-c-group d-c-group__footer">
              <div className="search-entered-text-group">
                Create <span className='search-entered-text'> "<span>Planning about the next level of designing the tasks Page</span>" </span>
              </div>
              <div className="d-c-g-f-btn-group">
               
                <button className="d-flex false btn btn-default active" type="button">
                  <span className="material-icons-outlined">add</span><p>Tasks</p>
                </button>
                <button className="d-flex false btn btn-default" type="button">
                  <span className="material-icons-outlined">add</span><p>Subtask</p>
                </button>
              </div>
            </div> */}
                    </div>
                  </div>
                </div>
                <div
                  className={`l-t-item l-t-i-priority ${log.taskId.priority.toLowerCase()}-prority`}
                >
                  {" "}
                  {log.taskId.priority}
                </div>
                <div className="l-t-item l-t-i-start-time">
                <input
                  type="text"
                  value={startTime[log._id] || log.starttime}
                  onChange={(e) => handleStartTimeChange(log._id, e)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      handleUpdate(log._id, startTime[log._id] || log.endtime, 'start'); // Call handleUpdate when Enter is pressed
                    }
                  }}
                />
                </div>
                <div className="l-t-item l-t-i-end-time">
                  {/* <input type="text" value={"--:-- --"} /> */}
                  <input
                    type="text"
                    value={endTime[log._id] ? endTime[log._id] : log.endtime === undefined ? "--:-- --" : log.endtime}
                    onChange={(e) => handleEndTimeChange(log._id, e)}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        handleUpdate(log._id, endTime[log._id] || log.endtime, 'end'); // Call handleUpdate when Enter is pressed
                      }
                    }}
                  />
                </div>

                <div className="l-t-item l-t-i-time-spent">
                  <input
                    type="text"
                    value={log.endtime === undefined ? timer : getTotalSpentTime(log.starttime, log.endtime)}
                  />  

                  {localStorage.getItem("_id") != log._id && (
                    <button onClick={() => handleDelete(log._id)} className="btn-comp l-w-timer-actions btn-icon btn-success">
                    <span className="material-icons-round">
                      delete
                    </span>
                  </button>
                  )}
                  
                  <button
                    className={`btn-comp l-w-timer-actions btn-icon btn-success
                       ${ log.endtime === undefined ? "active" : ""}
                    `}
                    onClick={() => {handleClone(log,log.endtime === undefined ? 'stop' : 'play')}}
                    disabled={
                      // Case 1: If there is an `_id` in localStorage, disable all buttons
                      localStorage.getItem("_id")
                        ? localStorage.getItem("_id") === log._id
                          ? false // Case 2: Enable if the `_id` matches `log._id`
                          : true  // Disable if it doesn't match
                        : false // If no `_id` is in localStorage, enable all buttons
                    }
                  >
                    <span className="material-icons-round icon-play">
                      play_arrow
                    </span>
                    <span className="material-icons-round icon-pause">
                      stop
                    </span>
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default LogTimeList;
